import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('roadmap-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            roadmapHolder: null,
            roadmapItems: null,
            roadmapTitles: null,
            lineHeight: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.roadmapItems = this.$el.querySelectorAll('.roadmap__item');
        this.roadmapHolder = document.querySelector('.roadmap-holder');
        this.roadmapTitles = this.$el.querySelectorAll('.roadmap__item h3');
        gsap.registerPlugin(ScrollTrigger);
        gsap.delayedCall(0.5, this.setLineHeight);
        gsap.delayedCall(0.5, this.setTimeline);
        EventBus.$on('window-resize', () => {
            this.setLineHeight();
            this.setTimeline();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setLineHeight() {
            this.lineHeight = this.roadmapHolder.getBoundingClientRect().height - this.roadmapItems[this.roadmapItems.length - 1].getBoundingClientRect().height;
    
            gsap.set('.roadmap__line', {
                height: this.lineHeight
            });
        },
        
        setTimeline() {
            const controller = ScrollTrigger.create({
                trigger: '.roadmap-container',
                start: 'top center',
                end: `${this.lineHeight} center`,
                onUpdate: ({ progress }) => {
                    gsap.set('.roadmap__line-fill', {
                        scaleY: progress
                    });
                }
            });

            const roadmapItem = this.$el.querySelectorAll('.roadmap__item');

            for (let i = 0; i < roadmapItem.length; i++) {
                const housesController = ScrollTrigger.create({
                    trigger: roadmapItem[i].querySelector('h3'),
                    start: 'top center',
                    end: 'bottom center',
                    onEnter: () => {
                        const svg = roadmapItem[i].querySelector('path');
                        gsap.to(svg, 0.5, {
                            fill: '#60C1B6'
                        });
                    },
                    onEnterBack: () => {
                        const svg = roadmapItem[i].querySelector('path');
                        gsap.to(svg, 0.5, {
                            fill: 'white'
                        });
                    }
                });
            }
        }
    }
});
